import { Button } from '@cdl/heartbeat-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackImportDelineation } from '../../analytics/thunks/track-import-delineation.thunk';
import {
  hideImportSelector,
  selectedDelineationSelector,
} from '../selectors/delineation.selectors';
import { importDelineation } from '../thunks/import-delineation.thunk';

export const DelineationImporter: React.FC = () => {
  const dispatch = useDispatch();
  const delineation = useSelector(selectedDelineationSelector);
  const hideImport = useSelector(hideImportSelector);

  if (hideImport || delineation == null) {
    return <></>;
  }

  return (
    <Button
      data-testid='import-btn'
      variant='quaternary'
      size='s'
      onClick={() => {
        dispatch(trackImportDelineation('import_button'));
        dispatch(importDelineation(delineation.id));
      }}
    >
      Import
    </Button>
  );
};
